var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90026 3.33335C8.90026 2.83629 8.49732 2.43335 8.00026 2.43335C7.5032 2.43335 7.10026 2.83629 7.10026 3.33335V7.10002H3.33359C2.83654 7.10002 2.43359 7.50296 2.43359 8.00002C2.43359 8.49707 2.83654 8.90002 3.33359 8.90002H7.10026V12.6667C7.10026 13.1637 7.5032 13.5667 8.00026 13.5667C8.49732 13.5667 8.90026 13.1637 8.90026 12.6667V8.90002H12.6669C13.164 8.90002 13.5669 8.49707 13.5669 8.00002C13.5669 7.50296 13.164 7.10002 12.6669 7.10002H8.90026V3.33335Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b23d65ed.svg";
export { ForwardRef as ReactComponent };